module.exports = __webpack_public_path__ + "static/media/outlet-live-logo.2f3feef5.svg";